import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useHouseholdExpensesChartsDataContext } from './hooks/useHouseholdExpensesChartsDataContext';

export const Gas = () => {
    const { chartData } = useHouseholdExpensesChartsDataContext();

    return (
        <SimpleBars
            title={'Gás'}
            horizontal={true}
            subtitles={chartData?.gas?.map((item) => item.description)}
            values={chartData?.gas?.map((item) => item.total  ||  0)}
            className='aligned-container'
        />
    );
};
